import {RelatedImage, TaskService} from '../../../index';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {TasksApi} from 'twict4fiber-api-web-rest-angular-17-v2';
import {DocumentsApi} from 'twict4fiber-api-web-rest-angular-17-v2';
import {TaskRelatedDocument} from '../../../specification/models/task-related-document.model';

@Injectable({providedIn: 'root'})
export class V2TaskService implements TaskService {

  public constructor(private readonly tasksApi: TasksApi,
                     private readonly documentsApi: DocumentsApi) {
  }

  getRelatedImages(taskUuid: string): Observable<RelatedImage[]> {
    return this.tasksApi.getImagesForTask(taskUuid);
  }

  getTaskRelatedDocuments(taskUuid: string): Observable<TaskRelatedDocument[]>{
    return this.documentsApi.getAllTaskRelatedDocuments(taskUuid);
  }
}
